import { CheckCircle2, Clock, HelpCircle, XCircle } from "lucide-react";

export const fmtSize = (bytes) => {
  if (!bytes) return "—";
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(2)} MB`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR"); } catch { return iso; }
};

export const STATUS_META = {
  success: { label: "Sucesso", color: "bg-emerald-100 text-emerald-800 border-emerald-300", icon: CheckCircle2 },
  error:   { label: "Erro",    color: "bg-red-100 text-red-800 border-red-300",             icon: XCircle },
  running: { label: "Rodando", color: "bg-blue-100 text-blue-800 border-blue-300",           icon: Clock },
  unknown: { label: "Legado",  color: "bg-slate-100 text-slate-700 border-slate-300",        icon: HelpCircle },
};
